import gql from 'graphql-tag';

export default gql`
	mutation ModalForgetPassword($isOpen: String) {
		updateModalForgetPassword(isOpen: $isOpen) @client
	}
`;
